// AminoBae Theme JS

(function () {
  'use strict';

  // ── AbortController: single teardown for all document/window listeners ─────
  // Calling ac.abort() removes every listener that was registered with
  // { signal: ac.signal } — no manual removeEventListener bookkeeping needed.
  // Fires on page hide (back/forward cache) and beforeunload (hard navigation).
  const ac = new AbortController();
  const sig = { signal: ac.signal };
  window.addEventListener('pagehide',     () => ac.abort(), { once: true });
  window.addEventListener('beforeunload', () => ac.abort(), { once: true });

  // ============================================================
  // SPEED DIAL FAB
  // ============================================================
  (function () {
    const dial    = document.getElementById('ab-speed-dial');
    const trigger = document.getElementById('ab-speed-dial-trigger');
    if (!dial || !trigger) return;

    function openDial() {
      dial.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function closeDial() {
      dial.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      dial.classList.contains('is-open') ? closeDial() : openDial();
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!dial.contains(e.target)) closeDial();
    }, sig);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDial();
    }, sig);

    // Workout Tracker / Body Composition / WhatsApp are plain links —
    // no JS needed beyond closing the dial after a tap, which the outside-click
    // handler above already does once focus moves to the new page.

    // Search FAB — close the dial and trigger the existing header search panel.
    document.getElementById('ab-fab-search')?.addEventListener('click', function () {
      closeDial();
      const searchTrigger = document.getElementById('search-trigger') ||
                            document.querySelector('[data-search-trigger]') ||
                            document.querySelector('.search-trigger');
      if (searchTrigger) {
        searchTrigger.click();
      } else {
        const input = document.querySelector('.predictive-search__input, #search-input');
        if (input) input.focus();
      }
    });
  })();

  // ============================================================
  // STANDALONE BACK-TO-TOP FAB
  // Sits next to the speed dial. Hidden until the user scrolls
  // past 280px so it doesn't crowd the corner on the hero.
  // ============================================================
  (function () {
    const btn = document.getElementById('ab-back-to-top');
    if (!btn) return;
    const SHOW_AFTER = 280;
    let ticking = false;
    function syncVisibility() {
      btn.classList.toggle('is-visible', window.scrollY > SHOW_AFTER);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(syncVisibility);
    }, { passive: true, signal: ac.signal });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    syncVisibility();
  })();



  // ============================================================
  // HELPERS
  // ============================================================
  const FREE_SHIPPING_THRESHOLD = 49900; // ₹499 in paise

  function formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // WCAG 4.1.3 — Announce cart state changes to screen readers via aria-live.
  // Debounced so rapid qty taps don't flood VoiceOver/TalkBack with every step.
  let _announceTimer = null;
  function announceCart(message) {
    const live = document.getElementById('cart-sr-live');
    if (!live) return;
    clearTimeout(_announceTimer);
    _announceTimer = setTimeout(function() {
      live.textContent = '';
      // Tiny gap forces AT to re-read even if message is identical to last one
      requestAnimationFrame(function() { live.textContent = message; });
    }, 150);
  }
  // Expose so PDP / quick-add can announce their own messages
  window.announceCart = announceCart;

  // Helper: Collect all keyboard-focusable nodes inside a container (WCAG 2.1.2)
  function getFocusable(container) {
    if (!container) return [];
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), ' +
        'select:not([disabled]), textarea:not([disabled]), ' +
        '[tabindex]:not([tabindex="-1"])'
      )
    ).filter(el => !el.closest('[hidden]') && !el.closest('[aria-hidden="true"]'));
  }

  // ============================================================
  // SCROLL REVEAL (Intersection Observer)
  // ============================================================
  if ('IntersectionObserver' in window) {
    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('[data-animate]').forEach(el => revealObs.observe(el));

    // Re-run for dynamically added elements. Scope to <main> instead of
    // document.body — prevents firing on every cart-drawer toggle, mega-menu
    // hover, search overlay open, etc. Cuts mutation callback frequency by ~10x.
    // Also debounce so multiple rapid mutations only trigger one re-scan.
    const mainEl = document.getElementById('main-content') || document.body;
    let mutTimer = null;
    const mutObs = new MutationObserver(() => {
      if (mutTimer) return;
      mutTimer = requestAnimationFrame(() => {
        mutTimer = null;
        document.querySelectorAll('[data-animate]:not(.is-visible)').forEach(el => revealObs.observe(el));
      });
    });
    mutObs.observe(mainEl, { childList: true, subtree: true });
  } else {
    // Fallback: show all immediately
    document.querySelectorAll('[data-animate]').forEach(el => el.classList.add('is-visible'));
  }

  // ============================================================
  // STICKY HEADER SCROLL CLASS
  // M6 FIX: header.liquid's handleScroll() is the single authority
  // for managing .scrolled on #site-header. The fallback listener
  // here was creating a second window scroll handler. Removed.
  // If header.liquid JS has not run (edge-case), the header simply
  // won't have .scrolled — far better than two competing listeners.
  // ============================================================

  // ============================================================
  // CART DRAWER
  // ============================================================
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartBody    = document.getElementById('cart-drawer-items');
  const cartFooter  = document.getElementById('cart-drawer-footer');
  const cartSubtotal = document.getElementById('cart-subtotal');

  // H7 — iOS-safe scroll lock.
  // `overflow:hidden` alone does NOT prevent iOS Safari 15–16 from scrolling
  // the page behind the overlay. The correct pattern is position:fixed + storing
  // and restoring window.scrollY so the page doesn't jump on close.
  let _cartScrollY = 0;
  let _cartPreviousActiveElement = null;
  let _cartFocusTrapHandler = null;

  function openCart() {
    if (!cartDrawer) return;
    _cartPreviousActiveElement = document.activeElement;
    _cartScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top      = `-${_cartScrollY}px`;
    document.body.style.width    = '100%';
    document.body.style.overflow = 'hidden';
    // Fix: overscroll-behavior: none stops iOS rubber-band scroll from
    // bleeding through to the page behind the cart drawer — the root cause
    // of the 'dark area below footer' bug on mobile Safari.
    document.body.style.overscrollBehavior = 'none';
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    const closeBtn = cartDrawer.querySelector('.cart-drawer__close, #cart-close-btn');
    setTimeout(() => closeBtn?.focus(), 50);
    if (window.eliteLenis) window.eliteLenis.stop();

    // WCAG 2.1.2 — Focus trap: cycle Tab / Shift+Tab within the cart drawer
    if (!_cartFocusTrapHandler) {
      _cartFocusTrapHandler = function (e) {
        if (e.key !== 'Tab') return;
        const focusable = getFocusable(cartDrawer);
        if (!focusable.length) return;
        const first = focusable[0];
        const last  = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      };
      document.addEventListener('keydown', _cartFocusTrapHandler);
    }
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.width    = '';
    document.body.style.overflow = '';
    document.body.style.overscrollBehavior = '';
    window.scrollTo(0, _cartScrollY);
    if (window.eliteLenis) window.eliteLenis.start();

    // Remove focus trap listener
    if (_cartFocusTrapHandler) {
      document.removeEventListener('keydown', _cartFocusTrapHandler);
      _cartFocusTrapHandler = null;
    }

    // WCAG 2.4.3: Return focus to the trigger that opened the cart
    if (_cartPreviousActiveElement && typeof _cartPreviousActiveElement.focus === 'function') {
      setTimeout(() => {
        try { _cartPreviousActiveElement.focus(); } catch (err) {}
        _cartPreviousActiveElement = null;
      }, 50);
    }
  }

  // Expose for PDP / mobile sticky ATC / quick-add buttons
  window.openCart = openCart;
  window.closeCart = closeCart;

  document.getElementById('cart-trigger')?.addEventListener('click', openCart);
  document.getElementById('cart-close-btn')?.addEventListener('click', closeCart);
  // P0-#1 FIX: Removed duplicate .cart-drawer__close listener — #cart-close-btn IS the .cart-drawer__close element.
  // Binding both caused closeCart() to fire twice per click.
  cartDrawer?.querySelector('.cart-drawer__overlay')?.addEventListener('click', closeCart);

  // ── P2-#12: SWIPE-DOWN-TO-CLOSE on cart drawer (mobile) ──────────────────────
  // On mobile the cart slides up from the bottom. A downward swipe on the
  // header area (or the full inner panel) dismisses it — matching native iOS
  // sheet/drawer behaviour.
  (function initCartSwipeToDismiss() {
    const inner = cartDrawer?.querySelector('.cart-drawer__inner');
    if (!inner || !('ontouchstart' in window)) return;
    let _csY = 0, _csX = 0, _csTracking = false;
    inner.addEventListener('touchstart', (e) => {
      // Only start swipe tracking when the scroll body is at the top
      const body = inner.querySelector('.cart-drawer__body');
      if (body && body.scrollTop > 5) return;
      _csY = e.touches[0].clientY;
      _csX = e.touches[0].clientX;
      _csTracking = true;
    }, { passive: true });
    inner.addEventListener('touchmove', (e) => {
      if (!_csTracking) return;
      const dy = e.touches[0].clientY - _csY;
      const dx = Math.abs(e.touches[0].clientX - _csX);
      // Cancel if horizontal swipe dominates (user is scrolling the upsell rail)
      if (dx > 30) { _csTracking = false; }
    }, { passive: true });
    inner.addEventListener('touchend', (e) => {
      if (!_csTracking) return;
      _csTracking = false;
      const endY = e.changedTouches[0].clientY;
      const dy = endY - _csY;
      const dx = Math.abs(e.changedTouches[0].clientX - _csX);
      // 60px threshold, must be more vertical than horizontal
      if (dy > 60 && dy > dx) closeCart();
    }, { passive: true });
  })();

  // Safety guard: guarantee document.body scroll is unlocked on initial page load
  if (!cartDrawer || cartDrawer.getAttribute('aria-hidden') === 'true') {
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.width    = '';
    document.body.style.overflow = '';
    document.body.classList.remove('cart-open');
  }

  // ============================================================
  // FREE SHIPPING PROGRESS BAR
  // ============================================================
  function updateShippingBar(totalPrice) {
    const fill = document.getElementById('shipping-fill');
    const msg = document.getElementById('shipping-msg');
    if (!fill || !msg) return;

    const pct = Math.min(100, (totalPrice / FREE_SHIPPING_THRESHOLD) * 100);
    fill.style.width = pct + '%';

    if (totalPrice >= FREE_SHIPPING_THRESHOLD) {
      msg.innerHTML = '🎉 <strong>You unlocked FREE shipping!</strong>';
      fill.classList.add('shipping-fill--complete');
    } else {
      fill.dataset.celebrated = '';
      fill.classList.remove('shipping-fill--complete');
      const remaining = formatMoney(FREE_SHIPPING_THRESHOLD - totalPrice);
      msg.innerHTML = `Add <strong>${remaining}</strong> more for <strong>FREE shipping</strong> 🚀`;
    }
  }

  // ============================================================
  // CART RENDERING
  // ============================================================
  function renderCartDrawer(cart) {
    if (!cartBody) return;

    // Update navbar badge
    const countEl = document.getElementById('cart-count');
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
      countEl.classList.remove('pulse');
      void countEl.offsetWidth;
      countEl.classList.add('pulse');
    }

    // Update header badge
    const countBadge = document.getElementById('cart-count-badge');
    if (countBadge) {
      countBadge.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    }

    // Update footer subtotal
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    if (cartFooter) cartFooter.style.display = cart.item_count > 0 ? '' : 'none';

    // Update shipping bar
    updateShippingBar(cart.total_price);

    // Show/hide upsell
    const upsellEl = document.getElementById('cart-upsell');
    if (upsellEl) upsellEl.style.display = cart.item_count > 0 ? '' : 'none';

    // Re-render cart body
    if (cart.item_count === 0) {
      cartBody.innerHTML = `
        <div class="cart-drawer__empty">
          <div class="cart-drawer__empty-icon">
            <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
          </div>
          <p class="cart-drawer__empty-title">Your stack is empty</p>
          <p class="cart-drawer__empty-sub">Start building your performance protocol</p>
          <a href="/collections/all" class="btn btn--primary">Shop All Products</a>
        </div>`;
      return;
    }

    const svgMinus  = `<svg width="12" height="2" viewBox="0 0 12 2" fill="currentColor" aria-hidden="true"><rect width="12" height="2" rx="1"/></svg>`;
    const svgPlus   = `<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><rect x="5" y="0" width="2" height="12" rx="1"/><rect x="0" y="5" width="12" height="2" rx="1"/></svg>`;
    const svgTrash  = `<svg width="13" height="14" viewBox="0 0 13 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 3.5h11M4.5 3.5V2.5a1 1 0 011-1h2a1 1 0 011 1v1M10.5 3.5l-.7 8a1 1 0 01-1 .9H4.2a1 1 0 01-1-.9l-.7-8"/><path d="M5 6.5v3M8 6.5v3"/></svg>`;

    cartBody.innerHTML = cart.items.map((item, idx) => {
      const imgSrc  = item.image ? item.image.replace('http:', 'https:') : '';
      const imgHtml = imgSrc
        ? `<img src="${imgSrc}" alt="${item.product_title}" width="88">`
        : `<div class="cart-item__img-placeholder"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" opacity="0.4"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>`;
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="cart-item__variant">${item.variant_title}</p>` : '';
      let propsHtml = '';
      if (item.properties) {
        const propEntries = Array.isArray(item.properties)
          ? item.properties
          : Object.entries(item.properties).map(([name, value]) => ({ name, value }));
        const visibleProps = propEntries.filter(p => {
          const k = p.name || p[0] || '';
          const v = p.value || p[1] || '';
          return !k.startsWith('_') && v && v.toString().trim() !== '';
        });
        if (visibleProps.length > 0) {
          propsHtml = `<div class="cart-item__props">${visibleProps.map(p => {
            const k = p.name || p[0];
            const v = p.value || p[1];
            return `<div class="cart-item__prop"><span class="cart-item__prop-key">${k}:</span> <span class="cart-item__prop-val">${v}</span></div>`;
          }).join('')}</div>`;
        }
      }
      const perItem = item.quantity > 1 ? `<p class="cart-item__per-unit">${formatMoney(item.final_line_price / item.quantity)} each</p>` : '';
      return `
        <div class="cart-item" data-key="${item.key}" data-variant-id="${item.variant_id}" style="--item-delay:${idx * 0.06}s">
          <div class="cart-item__image">${imgHtml}</div>
          <div class="cart-item__details">
            <div class="cart-item__top-row">
              <p class="cart-item__title">${item.product_title}</p>
              <button class="cart-item__remove" data-key="${item.key}" aria-label="Remove ${item.product_title} from cart">${svgTrash}</button>
            </div>
            ${variant}
            ${propsHtml}
            ${perItem}
            <div class="cart-item__price-qty">
              <span class="cart-item__price" aria-label="Line total">${formatMoney(item.final_line_price)}</span>
              <div class="cart-item__qty">
                <button class="qty-btn" data-action="decrease" data-key="${item.key}" aria-label="Decrease quantity of ${item.product_title}">${svgMinus}</button>
                <span class="qty-val" aria-live="polite" aria-label="Quantity">${item.quantity}</span>
                <button class="qty-btn" data-action="increase" data-key="${item.key}" aria-label="Increase quantity of ${item.product_title}">${svgPlus}</button>
              </div>
            </div>
          </div>
        </div>`;
    }).join('');

    // WCAG 4.1.3 — announce the updated cart state once rendering is done
    const total = formatMoney(cart.total_price);
    announceCart(
      cart.item_count === 1
        ? `Cart updated. 1 item. Total ${total}.`
        : `Cart updated. ${cart.item_count} items. Total ${total}.`
    );
  }

  // Expose for PDP / mobile sticky ATC / quick-add buttons
  window.renderCartDrawer = renderCartDrawer;

  async function refreshCart() {
    try {
      // Append a timestamp to bust Shopify's CDN cache — without this,
      // /cart.js can return stale data for 1–2 seconds after /cart/add.js
      // mutates the cart, causing the mini-cart to show the old state.
      const res  = await fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' });
      const cart = await res.json();
      renderCartDrawer(cart);
      return cart;
    } catch (err) {
      console.error('Cart refresh error:', err);
    }
  }

  // Expose for PDP / mobile sticky ATC / quick-add buttons
  window.refreshCart = refreshCart;

  // Init: render cart from server state on page load
  refreshCart();

  // ============================================================
  // CART DISCOUNT CODE
  // Code is stored in localStorage and appended to checkout URL
  // as ?discount=CODE — Shopify validates it at checkout.
  // Uses event delegation so handlers survive any cart re-render.
  // ============================================================
  (function () {
    var DISCOUNT_KEY = 'aminobae_discount_code';

    function $(id) { return document.getElementById(id); }

    function setCheckoutHref(code) {
      var btn = $('cart-checkout-btn');
      if (!btn) return;
      // Use routes.checkout_url equivalent — Shopify markets/multi-currency safe
      var base = btn.getAttribute('data-checkout-url') || '/checkout';
      btn.setAttribute('href', code ? base + '?discount=' + encodeURIComponent(code) : base);
    }

    function setMsg(text, kind) {
      var msg = $('cart-discount-msg');
      if (!msg) return;
      msg.textContent = text || '';
      msg.classList.remove('cart-discount__msg--ok', 'cart-discount__msg--err');
      if (kind) msg.classList.add('cart-discount__msg--' + kind);
    }

    function showApplied(code) {
      var root = $('cart-discount'),
          panel = $('cart-discount-panel'),
          applied = $('cart-discount-applied'),
          toggle = $('cart-discount-toggle'),
          appliedCode = $('cart-discount-applied-code'),
          line = $('cart-discount-line'),
          lineCode = $('cart-discount-line-code');
      if (panel)   panel.hidden = true;
      if (applied) applied.hidden = false;
      if (toggle)  toggle.setAttribute('aria-expanded', 'false');
      if (root)    root.setAttribute('data-applied', 'true');
      if (appliedCode) appliedCode.textContent = code;
      // Subtotal-row preview
      if (line)     line.hidden = false;
      if (lineCode) lineCode.textContent = code;
    }

    function hideAll() {
      var root = $('cart-discount'),
          panel = $('cart-discount-panel'),
          applied = $('cart-discount-applied'),
          toggle = $('cart-discount-toggle'),
          input = $('cart-discount-input'),
          line = $('cart-discount-line');
      if (panel)   panel.hidden = true;
      if (applied) applied.hidden = true;
      if (toggle)  toggle.setAttribute('aria-expanded', 'false');
      if (root)    root.removeAttribute('data-applied');
      if (input)   input.value = '';
      if (line)    line.hidden = true;
      setMsg('', '');
    }

    function applyCode(code) {
      var c = (code || '').trim().toUpperCase();
      if (!c) return;
      try { localStorage.setItem(DISCOUNT_KEY, c); } catch (e) {}
      setCheckoutHref(c);
      showApplied(c);
    }

    function removeCode() {
      try { localStorage.removeItem(DISCOUNT_KEY); } catch (e) {}
      setCheckoutHref('');
      hideAll();
    }

    // Restore from localStorage on load.
    try {
      var stored = localStorage.getItem(DISCOUNT_KEY);
      if (stored && stored.trim()) {
        showApplied(stored.trim().toUpperCase());
        setCheckoutHref(stored.trim().toUpperCase());
      } else if (stored !== null) {
        // Empty string saved by an earlier bug — clean up.
        try { localStorage.removeItem(DISCOUNT_KEY); } catch (e) {}
      }
    } catch (e) {}

    // Event delegation — survives any DOM re-render of the cart drawer.
    document.addEventListener('click', function (e) {
      // Toggle: collapse ↔ expand
      var t = e.target.closest('#cart-discount-toggle');
      if (t) {
        var panel = $('cart-discount-panel'),
            input = $('cart-discount-input');
        if (!panel) return;
        var willOpen = !!panel.hidden;
        panel.hidden = !willOpen;
        t.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen && input) setTimeout(function () { input.focus(); }, 60);
        return;
      }
      // Remove (X)
      var r = e.target.closest('#cart-discount-remove, [data-discount-remove]');
      if (r) {
        e.preventDefault();
        e.stopPropagation();
        removeCode();
        return;
      }
    }, sig);

    // Submit form
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('#cart-discount-form');
      if (!f) return;
      e.preventDefault();
      var input = $('cart-discount-input'),
          applyBtn = $('cart-discount-apply');
      var code = ((input && input.value) || '').trim().toUpperCase();
      if (!code) {
        setMsg('Please enter a code', 'err');
        if (input) input.focus();
        return;
      }
      if (applyBtn) { applyBtn.classList.add('is-loading'); applyBtn.disabled = true; }

      // Validate against Shopify before accepting.
      // GET /discount/CODE with redirect:'follow':
      //   valid code   → Shopify redirects to /checkouts/... or /checkout (res.url contains 'checkout')
      //   invalid code → Shopify redirects back to homepage / (res.url does NOT contain 'checkout')
      fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        redirect: 'follow',
        credentials: 'same-origin'
      })
      .then(function (res) {
        if (applyBtn) { applyBtn.classList.remove('is-loading'); applyBtn.disabled = false; }
        // M5 FIX: Broader URL match handles Shopify Markets (/checkouts/cn/), B2B,
        // and the legacy /checkout path. All Shopify checkout entries are recognised.
        var finalUrl = res.url || '';
        var isValid = (
          finalUrl.indexOf('/checkouts') !== -1 ||
          finalUrl.indexOf('/checkout') !== -1 ||
          finalUrl.indexOf('/cart') !== -1 // some Markets stores redirect back to cart with code applied
        );
        // Secondary guard: Shopify sometimes 200-redirects to homepage for invalid codes.
        // If the final URL is just the store root or /collections, treat as invalid.
        var isHomepage = /^https?:\/\/[^/]+(\/|\/collections\/?)?$/.test(finalUrl);
        if (isValid && !isHomepage) {
          applyCode(code);
        } else {
          setMsg('Invalid or expired code. Please try again.', 'err');
          if (input) input.focus();
        }
      })
      .catch(function () {
        // M5 FIX: Network error fallback — apply the code optimistically and let
        // Shopify validate it at checkout. This is better than blocking the user
        // on a connectivity issue. Advisory message explains the situation.
        if (applyBtn) { applyBtn.classList.remove('is-loading'); applyBtn.disabled = false; }
        applyCode(code);
        setMsg('Code applied. Shopify will validate it at checkout.', 'ok');
      });
    }, sig);

    // Auto-uppercase as user types
    document.addEventListener('input', function (e) {
      if (!e.target.matches || !e.target.matches('#cart-discount-input')) return;
      var pos = e.target.selectionStart;
      var up  = e.target.value.toUpperCase();
      if (up !== e.target.value) {
        e.target.value = up;
        try { e.target.setSelectionRange(pos, pos); } catch (err) {}
      }
    }, sig);
  })();

  // ============================================================
  // ADD TO CART
  // ============================================================
  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: parseInt(variantId), quantity })
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.description || 'Add to cart failed');
    }
    await refreshCart();
    openCart();
  }

  // ============================================================
  // PRODUCT PAGE "ADD TO CART" BUTTON
  // ============================================================
  const addToCartBtn = document.getElementById('add-to-cart');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async function () {
      const variantId = this.dataset.variantId;
      const qty = parseInt(document.getElementById('product-qty')?.value || 1);
      if (!variantId) return;

      this.textContent = 'Adding…';
      this.disabled = true;
      try {
        await addToCart(variantId, qty);
        this.textContent = 'Added ✓';
        setTimeout(() => { this.textContent = 'Add to Cart'; this.disabled = false; }, 1600);
      } catch (e) {
        this.textContent = 'Try again';
        this.disabled = false;
        // M4 FIX: Only log errors in Shopify theme editor — not in production storefronts
        if (window.Shopify?.designMode) console.error('[AminoBae] ATC error:', e);
      }
    });
  }

  // ============================================================
  // CARD "ADD" BUTTONS — event delegation, works for dynamic content.
  // Bound to BOTH click and touchend so the handler is reached even when
  // a third-party script (Shopify Web Pixels Manager, embedded apps,
  // tracking pixels via content_for_header) intercepts the synthesized
  // click on touch. Once handleQuickAdd has run, ranQuickAdd is set so
  // the duplicate click that follows touchend is no-op.
  // ============================================================
  async function handleQuickAdd(e) {
    const btn = e.target.closest('.quick-add-btn');
    if (!btn || btn.classList.contains('adding')) return;
    // Guard against double-firing (touchend + synthesized click).
    if (btn.dataset.qaRunning === '1') { e.preventDefault(); e.stopPropagation(); return; }
    btn.dataset.qaRunning = '1';
    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) { delete btn.dataset.qaRunning; return; }

    const originalHTML = btn.innerHTML;

    // ── LOADING STATE: spinner SVG
    btn.classList.add('adding');
    btn.innerHTML = '<svg class="atc-spinner" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10" stroke-opacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10" class="atc-arc"/></svg>';

    try {
      await addToCart(variantId, 1);
      btn.classList.remove('adding');
      btn.classList.add('added');
      // ── SUCCESS STATE: checkmark
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>';
    } catch (err) {
      btn.classList.remove('adding');
      btn.innerHTML = originalHTML;
      // M4 FIX: Only log errors in Shopify theme editor
      if (window.Shopify?.designMode) console.error('[AminoBae] Quick-add error:', err);
    }

    setTimeout(() => {
      btn.classList.remove('added');
      btn.innerHTML = originalHTML;
      delete btn.dataset.qaRunning;
    }, 1800);
  }
  document.addEventListener('click', handleQuickAdd);

  // ============================================================
  // CART DRAWER — QTY + REMOVE (no page reload)
  // Bound to document (not cartDrawer) so Lenis's data-lenis-prevent
  // on .cart-drawer__body cannot intercept/swallow the events.
  // ============================================================
  document.addEventListener('click', async function (e) {
    // Only act on clicks that originated inside the cart drawer
    if (!e.target.closest('#cart-drawer')) return;

    const qtyBtn    = e.target.closest('.qty-btn');
    const removeBtn = e.target.closest('.cart-item__remove');

    if (!qtyBtn && !removeBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const activeBtn = qtyBtn || removeBtn;
    const itemEl   = activeBtn.closest('.cart-item');
    const key       = activeBtn.dataset.key || itemEl?.dataset.key;
    if (!key) return;

    // Prevent double-clicks during the async fetch
    if (activeBtn.dataset.busy === '1') return;
    activeBtn.dataset.busy = '1';
    activeBtn.style.opacity = '0.5';

    let newQty;
    if (removeBtn) {
      newQty = 0;
    } else {
      const current = parseInt(itemEl?.querySelector('.qty-val')?.textContent || '1', 10);
      newQty = qtyBtn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
    }

    // ── Premium removal animation: slide out → collapse → re-render ──
    const isRemoving = newQty === 0;

    if (isRemoving && itemEl) {
      // Phase 1: slide the item out to the left
      itemEl.classList.add('cart-item--removing');
      await new Promise(r => setTimeout(r, 280));
      // Phase 2: collapse height smoothly
      itemEl.classList.add('cart-item--collapsing');
      await new Promise(r => setTimeout(r, 300));
    }

    // ── Qty pulse animation (for non-removal qty changes) ──
    if (!isRemoving && itemEl) {
      const qtyVal = itemEl.querySelector('.qty-val');
      const priceEl = itemEl.querySelector('.cart-item__price');
      if (qtyVal) {
        qtyVal.textContent = newQty;
        qtyVal.classList.remove('qty-val--pulse');
        void qtyVal.offsetWidth; // force reflow to restart animation
        qtyVal.classList.add('qty-val--pulse');
      }
      if (priceEl) {
        priceEl.classList.remove('cart-item__price--flash');
        void priceEl.offsetWidth;
        priceEl.classList.add('cart-item__price--flash');
      }
    }

    try {
      const res = await fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: String(key), quantity: Number(newQty) })
      });
      if (!res.ok && window.Shopify?.designMode) {
        // M4 FIX: Only log cart errors in theme editor
        console.error('[AminoBae] Cart update HTTP error:', res.status);
      }
      await refreshCart();
    } catch (err) {
      if (window.Shopify?.designMode) console.error('[AminoBae] Cart update error:', err);
    } finally {
      if (activeBtn.isConnected) {
        activeBtn.style.opacity = '';
        delete activeBtn.dataset.busy;
      }
    }
  });

  // ============================================================
  // WISHLIST — product card heart buttons
  // ============================================================
  function syncWishlistButtons() {
    document.querySelectorAll('.card-wishlist-btn[data-product-id]').forEach(btn => {
      const id = btn.dataset.productId;
      if (window.AminoBaeWishlist?.has(id)) {
        btn.classList.add('wishlisted');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        btn.classList.remove('wishlisted');
        btn.setAttribute('aria-label', btn.dataset.productTitle ? 'Save ' + btn.dataset.productTitle + ' to wishlist' : 'Save to wishlist');
      }
    });
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.card-wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (!window.AminoBaeWishlist) return;
    const id = btn.dataset.productId;
    if (window.AminoBaeWishlist.has(id)) {
      window.AminoBaeWishlist.remove(id);
      btn.classList.remove('wishlisted');
    } else {
      window.AminoBaeWishlist.add({
        id:       id,
        handle:   btn.dataset.productHandle,
        title:    btn.dataset.productTitle,
        price:    parseInt(btn.dataset.productPrice || '0'),
        image:    btn.dataset.productImage,
        url:      btn.dataset.productUrl
      });
      btn.classList.add('wishlisted');
      // Mini pop animation
      btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }], { duration: 300 });
    }
  }, sig);

  // Sync on load (page may have persisted state)
  if (window.AminoBaeWishlist) syncWishlistButtons();
  else document.addEventListener('aminobae:wishlist-ready', syncWishlistButtons);

  // ============================================================
  // MOBILE MENU
  // H7 — iOS-safe scroll lock (position:fixed pattern, same as cart).
  // H8 — Focus trap: when the drawer opens, focus moves to the close button.
  //       Tab / Shift+Tab cycle within the panel. Escape closes.
  // ============================================================
  const mobileNav = document.getElementById('mobile-nav');

  let _navScrollY = 0;
  let _navFocusTrapHandler = null;

  function openMobile() {
    if (!mobileNav) return;
    _navScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top      = `-${_navScrollY}px`;
    document.body.style.width    = '100%';
    document.body.style.overflow = 'hidden';
    // P1-#3 FIX: Prevent iOS rubber-band scroll from bleeding through to the
    // page behind the mobile nav drawer (same pattern as openCart).
    document.body.style.overscrollBehavior = 'none';
    mobileNav.setAttribute('aria-hidden', 'false');
    if (window.eliteLenis) window.eliteLenis.stop();

    // H8 — Move focus into the drawer immediately
    const closeBtn = document.getElementById('mobile-menu-close') ||
                     mobileNav.querySelector('button');
    setTimeout(() => closeBtn?.focus(), 60); // rAF-safe delay

    // H8 — Focus trap: cycle Tab/Shift+Tab inside the nav panel
    _navFocusTrapHandler = function (e) {
      if (e.key !== 'Tab') return;
      const panel = mobileNav.querySelector('#mobile-nav-panel, .mnav__panel') || mobileNav;
      const focusable = getFocusable(panel);
      if (!focusable.length) return;
      const first = focusable[0];
      const last  = focusable[focusable.length - 1];
      if (e.shiftKey) {
        // Shift+Tab at first element → wrap to last
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        // Tab at last element → wrap to first
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener('keydown', _navFocusTrapHandler);
  }

  function closeMobile() {
    if (!mobileNav) return;
    mobileNav.setAttribute('aria-hidden', 'true');
    // Restore scroll position before clearing position:fixed
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.width    = '';
    document.body.style.overflow = '';
    document.body.style.overscrollBehavior = '';
    window.scrollTo(0, _navScrollY);
    if (window.eliteLenis) window.eliteLenis.start();
    // Remove focus trap listener
    if (_navFocusTrapHandler) {
      document.removeEventListener('keydown', _navFocusTrapHandler);
      _navFocusTrapHandler = null;
    }
    // Return focus to the toggle button that opened the drawer
    document.getElementById('mobile-menu-toggle')?.focus();
  }

  document.getElementById('mobile-menu-toggle')?.addEventListener('click', openMobile);
  document.getElementById('mobile-menu-close')?.addEventListener('click', closeMobile);
  document.getElementById('mobile-backdrop')?.addEventListener('click', closeMobile);

  // ── P2-#11: SWIPE-LEFT-TO-CLOSE on mobile nav drawer ────────────────────────
  // The drawer slides in from the left. A leftward swipe anywhere on the panel
  // dismisses it — matching native mobile app conventions. Only triggers when
  // the horizontal distance exceeds 60px and dominates the vertical axis.
  (function initMobileNavSwipeToDismiss() {
    const panel = document.getElementById('mnav-panel');
    if (!panel || !('ontouchstart' in window)) return;
    let _nsX = 0, _nsY = 0;
    panel.addEventListener('touchstart', (e) => {
      _nsX = e.touches[0].clientX;
      _nsY = e.touches[0].clientY;
    }, { passive: true });
    panel.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].clientX;
      const endY = e.changedTouches[0].clientY;
      const dx = _nsX - endX; // positive = swipe left
      const dy = Math.abs(endY - _nsY);
      // 60px threshold, must be more horizontal than vertical
      if (dx > 60 && dx > dy) closeMobile();
    }, { passive: true });
  })();

  // ============================================================
  // ESCAPE KEY — closes overlays
  // ============================================================
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    closeCart();
    closeMobile();
  });

  // ============================================================
  // BEFORE/AFTER SLIDER
  // C4 + L3 FIX: Replaced unscoped global window mousemove/touchmove
  // listeners (which leaked forever and multiplied per-card) with the
  // Pointer Events API + setPointerCapture pattern.
  //
  // setPointerCapture routes all pointer events to the slider element
  // for the duration of the drag — eliminating the need for window
  // listeners entirely. The capture is released on pointerup/cancel.
  // This approach works for mouse, touch, and stylus in one code path.
  // ============================================================
  document.querySelectorAll('.before-after-card__slider').forEach(slider => {
    const after  = slider.querySelector('.before-after-card__after');
    const handle = slider.querySelector('.before-after-card__handle');

    function setPosition(clientX) {
      const rect = slider.getBoundingClientRect();
      const pct  = Math.min(Math.max((clientX - rect.left) / rect.width * 100, 0), 100);
      after.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      handle.style.left = pct + '%';
    }

    slider.addEventListener('pointerdown', e => {
      // Only respond to primary pointer button
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      e.preventDefault();
      slider.setPointerCapture(e.pointerId);
      setPosition(e.clientX);
    });

    // pointermove only fires here because of setPointerCapture — no window listener needed
    slider.addEventListener('pointermove', e => {
      if (!slider.hasPointerCapture(e.pointerId)) return;
      setPosition(e.clientX);
    });

    slider.addEventListener('pointerup', e => {
      slider.releasePointerCapture(e.pointerId);
    });
    slider.addEventListener('pointercancel', e => {
      slider.releasePointerCapture(e.pointerId);
    });
  });

  // ============================================================
  // SCROLL REVEAL (secondary)
  // C1 FIX: This second observer was redundant — it added .reveal
  // and .visible classes that have no CSS rules, while the primary
  // IO observer in theme.js L119 already handles [data-animate]
  // elements and the GSAP engine in global-animations.js handles
  // advanced stagger reveals. This observer has been removed to
  // prevent the three-system conflict. Card stagger delays are
  // applied via the [data-animate-delay] attribute in each section.
  // ============================================================

  // ============================================================
  // PRODUCT CARD — neon green spotlight border glow
  // Perf: rect is read only when moving onto a NEW card (not every event).
  // CSS-var writes are batched inside rAF so they never block a scroll frame.
  // ============================================================
  (function() {
    let _sCard = null, _sRect = null, _sX = 0, _sY = 0, _sRaf = false;

    document.addEventListener('mousemove', function(e) {
      const card = e.target.closest('.product-card');
      if (!card) { _sCard = null; return; }
      // Re-read rect only when the cursor enters a different card
      if (card !== _sCard) { _sCard = card; _sRect = card.getBoundingClientRect(); }
      _sX = e.clientX; _sY = e.clientY;
      if (_sRaf) return; // already a frame queued
      _sRaf = true;
      requestAnimationFrame(function() {
        if (_sCard && _sRect) {
          _sCard.style.setProperty('--card-x', ((_sX - _sRect.left) / _sRect.width  * 100) + '%');
          _sCard.style.setProperty('--card-y', ((_sY - _sRect.top)  / _sRect.height * 100) + '%');
        }
        _sRaf = false;
      });
    }, { passive: true });

    // Reset vars to off-screen on mouseleave so the glow gradient fully
    // collapses and cannot bleed onto adjacent cards as a phantom.
    document.addEventListener('mouseleave', function(e) {
      const card = e.target.closest('.product-card');
      if (!card) return;
      card.style.setProperty('--card-x', '-9999px');
      card.style.setProperty('--card-y', '-9999px');
      _sCard = null; _sRect = null;
    }, { capture: true, passive: true });

    // Invalidate cached rect on resize so it stays accurate
    window.addEventListener('resize', function() { _sRect = null; _sCard = null; }, { passive: true });
  })();

  // ============================================================
  // DRAG-TO-SCROLL (Desktop Swipe)
  // Hard-gate: skip entirely if the device is touch-capable. Native
  // overflow-x: auto already gives momentum scrolling on touch; we don't
  // need a JS drag detector AND we eliminate the synthesized-mousemove
  // edge case that previously killed taps on small buttons inside rails.
  // ============================================================
  const isTouchDevice =
    window.matchMedia('(pointer: coarse)').matches ||
    window.matchMedia('(any-pointer: coarse)').matches ||
    ('ontouchstart' in window);
  const rails = isTouchDevice
    ? []
    : document.querySelectorAll('.cart-upsell__rail, .video-reel, .tabbed-collection__controls, .swipe-rail');
  rails.forEach(rail => {
    // Bulletproof drag prevention for links and images
    rail.querySelectorAll('a, img').forEach(el => el.setAttribute('draggable', 'false'));

    let isDown = false;
    let startX;
    let startPageX;
    let scrollLeft;
    let moved = false;
    // Skip mouse drag detection when the input is touch. Touch already gets
    // native momentum scrolling via CSS overflow-x: auto, so we don't need
    // a JS drag detector — and iOS synthesizes mouse events from touch with
    // small jitter that previously caused real taps on the right side of
    // small buttons (e.g. card-atc-btn) to be mistaken for swipes and
    // silently swallowed by the stopOnce click suppressor below.
    let touchActive = false;
    // 10px threshold: < 10px is intent-to-click, ≥ 10px is intent-to-drag.
    const DRAG_THRESHOLD = 10;

    rail.addEventListener('touchstart', () => { touchActive = true; }, { passive: true });
    rail.addEventListener('touchend',   () => {
      // Clear AFTER the synthesized click has had a chance to fire (~350ms
      // covers the legacy iOS click delay envelope and any retargeting).
      setTimeout(() => { touchActive = false; }, 350);
    }, { passive: true });

    rail.addEventListener('dragstart', (e) => e.preventDefault());

    rail.addEventListener('mousedown', (e) => {
      if (touchActive) return; // touch is driving — skip mouse drag logic
      isDown = true;
      rail.classList.add('is-dragging');
      startX = e.pageX - rail.offsetLeft;
      startPageX = e.pageX;
      scrollLeft = rail.scrollLeft;
      moved = false;
    });

    rail.addEventListener('mouseleave', () => {
      isDown = false;
      rail.classList.remove('is-dragging');
    });

    rail.addEventListener('mouseup', () => {
      const wasMoved = moved;
      isDown = false;
      moved = false;
      rail.classList.remove('is-dragging');
      if (!wasMoved) return;
      // Suppress exactly the next click within this rail, and only briefly.
      // { once: true } auto-removes after first click; the setTimeout removes
      // it if no click follows — prevents an orphan handler from swallowing
      // a future, unrelated click.
      const stopOnce = (ev) => { ev.stopImmediatePropagation(); ev.preventDefault(); };
      rail.addEventListener('click', stopOnce, { capture: true, once: true });
      setTimeout(() => rail.removeEventListener('click', stopOnce, true), 200);
    });

    // M7 FIX: Drag speed is now configurable per-rail via data-drag-speed attribute.
    // Default 2.5 is preserved. Usage: <div class="swipe-rail" data-drag-speed="2">
    const dragSpeed = parseFloat(rail.dataset.dragSpeed) || 2.5;

    rail.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const x = e.pageX - rail.offsetLeft;
      if (Math.abs(e.pageX - startPageX) > DRAG_THRESHOLD) moved = true;
      rail.scrollLeft = scrollLeft - (x - startX) * dragSpeed;
    });
  });

  // ============================================================
  // FORCE AUTOPLAY — background videos on mobile
  // Mobile browsers sometimes block autoplay even with muted+playsinline.
  // This observer force-plays any .svbg__video when it enters the viewport.
  // ============================================================
  if ('IntersectionObserver' in window) {
    const videoObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const v = entry.target;
        if (entry.isIntersecting && v.paused) {
          v.play().catch(() => {});
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.svbg__video, video.svbg__video').forEach(v => {
      v.removeAttribute('controls');
      v.setAttribute('muted', '');
      v.muted = true;
      videoObs.observe(v);
    });

    // Also catch dynamically rendered videos
    const vidMutObs = new MutationObserver(() => {
      document.querySelectorAll('.svbg__video').forEach(v => {
        v.removeAttribute('controls');
        v.setAttribute('muted', '');
        v.muted = true;
        if (!v.__svbgObserved) {
          v.__svbgObserved = true;
          videoObs.observe(v);
        }
      });
    });
    // Scope to #main-content — not document.body. Observing body fires on
    // every cart re-render, menu toggle, and aria-hidden flip site-wide.
    const vidScope = document.getElementById('main-content') || document.body;
    vidMutObs.observe(vidScope, { childList: true, subtree: true });
  }

  // ============================================================
  // CUSTOM NEON CURSOR
  // Perf fixes applied:
  //   · transform instead of left/top → GPU-only composite, zero layout cost
  //   · Self-idling rAF loop → stops when ring settles, restarts on mousemove
  //   · { passive: true } on mousemove
  //   · ringHalf updated on hover so ring stays centred during size transition
  // ============================================================
  (function () {
    if (window.matchMedia('(pointer: coarse)').matches) return;

    const dot = document.querySelector('.cursor-dot');
    const ring = document.querySelector('.cursor-ring');
    if (!dot || !ring) return;

    const DOT_HALF = 3;   // dot is 6 px diameter
    let ringHalf   = 18;  // ring is 36 px normally, 54 px on hover
    let mouseX = -9999, mouseY = -9999;
    let ringX  = -9999, ringY  = -9999;
    let rafId  = null;

    function tick() {
      const dx = mouseX - ringX;
      const dy = mouseY - ringY;
      ringX += dx * 0.15;
      ringY += dy * 0.15;
      // GPU-composited: only transform, zero layout recalc
      ring.style.transform = `translate(${ringX - ringHalf}px, ${ringY - ringHalf}px)`;
      // Self-idle: stop scheduling frames once ring has caught up
      if (Math.abs(dx) > 0.1 || Math.abs(dy) > 0.1) {
        rafId = requestAnimationFrame(tick);
      } else {
        rafId = null;
      }
    }

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      // Dot snaps instantly — GPU-composited transform, no layout
      dot.style.transform = `translate(${mouseX - DOT_HALF}px, ${mouseY - DOT_HALF}px)`;
      // On the very first move: tell CSS the cursor is ready so cursor:none activates
      // (CSS loads before deferred JS — without this the native cursor disappears immediately)
      if (!document.body.classList.contains('js-cursor-ready')) {
        document.body.classList.add('js-cursor-ready');
      }
      // Wake the ring lerp loop if it has gone idle
      if (!rafId) rafId = requestAnimationFrame(tick);
    }, { passive: true });

    // P1-#9 FIX: Replaced getComputedStyle (forces style recalculation on every
    // mouseover) with a fast heuristic check using closest() against known
    // interactive element selectors. Covers 99.9% of cases without layout thrashing.
    document.addEventListener('mouseover', (e) => {
      const tgt = e.target;
      const el = (tgt && tgt.nodeType === 1) ? tgt : (tgt && tgt.parentElement && tgt.parentElement.nodeType === 1 ? tgt.parentElement : null);
      if (!el) return;
      const isInteractive =
        el.tagName === 'A' || el.tagName === 'BUTTON' || el.tagName === 'LABEL' ||
        el.tagName === 'SELECT' || el.tagName === 'SUMMARY' ||
        (typeof el.closest === 'function' && (
          !!el.closest('a') || !!el.closest('button') || !!el.closest('label') ||
          !!el.closest('[role="button"]') || !!el.closest('.btn') ||
          !!el.closest('.card-atc-btn') || !!el.closest('.quick-add-btn') ||
          !!el.closest('.card-wishlist-btn') || !!el.closest('.tab-btn') ||
          !!el.closest('.header-actions__btn') || !!el.closest('.qty-btn') ||
          !!el.closest('[tabindex="0"]') || !!el.closest('input[type="submit"]') ||
          !!el.closest('summary')
        ));
      const wasHover = dot.classList.contains('hover');
      if (!!isInteractive !== wasHover) {
        dot.classList.toggle('hover', !!isInteractive);
        ring.classList.toggle('hover', !!isInteractive);
        // Keep ring centred when it resizes on hover (36px→54px, half: 18→27)
        ringHalf = isInteractive ? 27 : 18;
      }
    });

    window.addEventListener('beforeunload', () => { document.body.classList.add('is-unloading'); });
    window.addEventListener('pageshow', (e) => { if (e.persisted) document.body.classList.remove('is-unloading'); });
  })();

})();

